import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { TeliaSegment, useSegment } from '@telialt/utils/src/segment';

import { ORDER_CART_TEST_ID } from '../../constants';
import { VatDisclaimer } from './CartVatNote.styles';

export const CartVatNote: FC = () => {
    const { t } = useTranslations();
    const segment = useSegment();

    if (segment === TeliaSegment.B2b) {
        return <VatDisclaimer data-test={ORDER_CART_TEST_ID.VAT_NOTE}>{t['order_cart.vat_disclaimer']}</VatDisclaimer>;
    }

    return null;
};
